import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Actions, ofType} from "@ngrx/effects";
import {OrderActions} from "../../store/actions/order.actions";
import {Standard, StandardName} from "../../store/state/order.state";

@Component({
    selector: 'copy-button',
    templateUrl: './copy-button.template.html',
    styleUrls: ['./copy-button.style.scss'],
    standalone: false
})
export class CopyButtonComponent implements OnInit {

	@Input() visible: boolean;
	@Input() text: string;
	@Input() standard: Standard;
	@Output() copyButtonClicked: EventEmitter<any> = new EventEmitter<any>();

	showCopiedNotification: boolean;
	copyActionDisabled: boolean = false;

	constructor(private actions$: Actions) {
	}

	ngOnInit(): void {
		this.actions$.pipe(ofType(OrderActions.REQUEST_ORDER)).subscribe(() => {
			this.copyActionDisabled = true;
		});
	}

	onCopyButtonClicked() {
		this.copyButtonClicked.emit();
		this.showCopiedNotification = true;

		setTimeout(() => this.showCopiedNotification = false, 5000);
	}
}
